// extracted by mini-css-extract-plugin
export var logo = "_bj-2";
export var logoWrapper = "_bj-1";
export var strip = "_bj-0";